<script lang="ts">
  import LoadingSpinner from "./LoadingSpinner.svelte";

  export let color = "accent";
  export let size = "small";
  export let loading = false;
  export let disabled = false;

  const DISABLED_MAP: Record<string, string> = {
    ["accent"]: "neutral-02",
    ["dark"]: "neutral-02",
    ["neutral-02"]: "neutral-01",
    ["light"]: "light",
  };

  const DISABLED_COLOR_MAP: Record<string, string> = {
    ["accent"]: "light",
    ["dark"]: "transparency-dark",
    ["neutral-02"]: "dark",
    ["light"]: "transparency-dark",
  };

  const COLOR_MAP: Record<string, string> = {
    ["accent"]: "light",
    ["dark"]: "light",
    ["neutral-02"]: "dark",
    ["light"]: "dark",
  };
</script>

<button
  style="--button-color: var(--rekki-{color}); --disabled-button-color: var(--rekki-{DISABLED_MAP[
    color
  ]}); --disabled-color: var(--rekki-{DISABLED_COLOR_MAP[
    color
  ]});--text-color: var(--rekki-{COLOR_MAP[color]})"
  class="text-{size} cursor-oversized button-{size}"
  on:click
  {disabled}
>
  {#if loading}
    <LoadingSpinner light size={10} />
  {:else}
    <slot />
  {/if}
</button>

<style>
  button {
    display: inline-flex;
    gap: 6px;
    flex-direction: row;
    box-sizing: border-box;
    flex: 0;
    border-radius: 40px;
    background-color: var(--button-color);
    font-family: "REKKI-OCD";
    padding: 16px 23px;
    color: var(--text-color);
    border: 0 none;
    white-space: nowrap;
    text-transform: uppercase;
    width: max-content;
  }

  button:disabled {
    background-color: var(--disabled-button-color) !important;
    color: var(--disabled-color);
  }

  button:active {
    filter: brightness(1.1);
  }

  .button-tiny {
    padding: 8px 16px;
  }
</style>
